"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const mobx_react_1 = require("mobx-react");
const ProductBox_1 = require("./Elements/ProductBox");
const Store_1 = require("./Store");
const ContentArea_1 = require("./Elements/ContentArea");
let ProductList = class ProductList extends React.Component {
    constructor(props) {
        super(props);
        Store_1.default.loadProducts();
        Store_1.default.updateNavigationColor(Store_1.default.containerId);
    }
    componentDidMount() {
        Store_1.default.siteName = "Original Long Drink";
        document.title = Store_1.default.currentPageName + " | " + Store_1.default.siteName;
    }
    render() {
        var backgroundStyle = {
            backgroundImage: 'url(' + Store_1.default.BackgroundImageUrl + '?width=' + Math.ceil($(window).width() / 100) * 100 + '&quality=70)'
        };
        let dimFilter = Store_1.default.DimFilter;
        let filterStyle = {};
        filterStyle.backgroundColor = 'black';
        filterStyle.opacity = 0.25;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "o-container" },
                React.createElement("div", { className: "o-product-listing-background u-full-width-viewport", style: backgroundStyle }, dimFilter && React.createElement("div", { className: "s-bg-cover background-image", style: filterStyle })),
                React.createElement("h1", { className: "u-tc s-hero s-themecolor-1 o-product-listing-heading" }, Store_1.default.currentPageName),
                React.createElement("div", { className: "o-product-listing-wrapper" },
                    Store_1.default.loading &&
                        React.createElement("div", { className: "ui active inverted dimmer" },
                            React.createElement("div", { className: "ui text loader" }, Store_1.default.Translations.loadingText)),
                    React.createElement("div", { className: "row u-pb-12" }, Store_1.default.Products && Store_1.default.Products.map(function (product, index) {
                        return (React.createElement(ProductBox_1.default, { key: product.id, product: product }));
                    })))),
            React.createElement(ContentArea_1.default, { content: Store_1.default.containerId, language: Store_1.default.currentLanguage, area: "ProductContentArea" })));
    }
};
ProductList = __decorate([
    mobx_react_1.observer
], ProductList);
exports.default = ProductList;
